export function array_dot(i, p){
    var o = {};p = p || '';

    if (p) { p = p+'.'; }

    if (typeof i == 'object')
    {
        for (var k in i)
        {
            if (i.hasOwnProperty(k))
            {
                if (typeof i[k] == 'object')
                {
                    var x = array_dot(i[k],k);
                    for(var l in x)
                    {
                        o[p+l] = x[l];
                    }
                }
                else
                {
                    o[p+k] = i[k];
                }
            }
        }
    }
    return o;
}

export function array_get(i,k,d)
{
    if (typeof d === 'undefined') { d = null; }
    if (!k) return i;

    var s = k.split('.');

    var o = i;

    for(var x=0;x < s.length; x++)
    {
        if (null !== o && o.hasOwnProperty(s[x]))
        {
            o = o[s[x]];
        }
        else
        {
            return d;
        }
    }

    return o;
}
